export default __webpack_public_path__ + "static/media/choose_route.56ceccfb.jpg";